"use client";

import { useTranslations } from "use-intl";

import { ExpandIcon, OfferIcon, TrendChartIcon } from "@/components/appIcons";
import { cn } from "@/lib/utils";

const HISTORY_BUTTON_VARIANTS = {
  link: "inline-flex min-h-11 items-center gap-1.5 rounded text-xs font-medium text-foreground underline-offset-4 hover:text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary lg:min-h-8",
  ghost:
    "inline-flex min-h-11 items-center gap-1.5 rounded-md px-2 text-xs font-bold text-muted-foreground transition-colors hover:bg-secondary/60 hover:text-foreground active:bg-secondary",
  outline:
    "inline-flex min-h-11 items-center justify-center gap-1.5 rounded-lg border border-border px-2.5 text-xs font-semibold text-foreground transition-colors hover:bg-secondary/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary active:bg-secondary lg:min-h-9",
} as const;

export function DealOfferHistoryButton({
  onClick,
  expanded,
  count,
  mode = "history",
  variant = "ghost",
  controls,
  className,
}: {
  onClick: () => void;
  expanded?: boolean;
  count?: number;
  mode?: "history" | "offers";
  /** `ghost` is the inline text button; `outline` is the bordered hero offer panel footer button. */
  variant?: "ghost" | "outline" | "link";
  /** Id of the region this toggle expands (sets aria-controls). */
  controls?: string;
  className?: string;
}) {
  const t = useTranslations("shared.affiliates");
  const label =
    mode === "offers" ? t("viewAllEditionOffers", { count: count ?? 1 }) : t("offerHistoryAction");
  const Icon = mode === "offers" ? OfferIcon : TrendChartIcon;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-expanded={expanded}
      aria-controls={controls}
      className={cn(HISTORY_BUTTON_VARIANTS[variant], className)}
    >
      <Icon className="text-base" />
      <span>{label}</span>
      {expanded != null && (
        <ExpandIcon
          className={cn("shrink-0 text-sm transition-transform", expanded && "rotate-180")}
        />
      )}
    </button>
  );
}
